import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { Load } from '../_models';
import { environment } from '../../../environments/environment';
import { selectAllLoads } from '../_selectors/load.selectors';
import { AppState } from '../_reducers';

@Injectable()
export class LoadService {
  private apiBaseUrl = environment.apiBaseUrl;
  loadList$: Observable<Load[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.loadList$ = this.store.pipe(select(selectAllLoads));
  }
  getLoadsFromLocalStore(): Observable<Load[]> {
    return this.loadList$;
  }

  getLoads(): Observable<Load[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/loads')
      .pipe(map((response) => response));
  }
  getLoad(id: number): Observable<Load> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/loads/' + id)
      .pipe(map((response) => response));
  }
  saveLoad(load): Observable<Load> {
    const loadCopy = { ...load };

    delete loadCopy.lastUpdated;
    delete loadCopy.dateCreated;

    if (loadCopy.user) {
      const iduser: any = {
        id: loadCopy.user.id,
      };
      loadCopy.user = iduser;
    }

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    loadCopy.companyId = companySelected ? companySelected.id : null;

    if (loadCopy.id) {
      return this.http
        .put<Load>(this.apiBaseUrl + 'api/private/v1/loads/' + loadCopy.id, loadCopy)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Load>(this.apiBaseUrl + 'api/private/v1/loads/', loadCopy)
        .pipe(map((response) => response));
    }
  }
  deleteLoad(id: number): Observable<Load> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/loads/' + id).pipe(
      map((response) => {
        return { id } as Load;
      })
    );
  }

  getLoadById = (id: number): Load => {
    let item: Load;
    this.loadList$
      .pipe(first((list: Load[]) => list && list.length > 0))
      .subscribe((list: Load[]) => {
        item = list.find((i) => i.id === id);
      });
    return item;
  };
}
